var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cust-xport-conf-crud" }, [
    _c(
      "div",
      {
        staticStyle: {
          "border-bottom": "1px dashed #EEEEEE",
          height: "40px",
          padding: "5px 10px",
          "line-height": "30px"
        }
      },
      [
        _c("span", [
          _vm._v(
            "导入模板【" +
              _vm._s(_vm.confTitle) +
              "】- " +
              _vm._s(_vm.confUsage) +
              " 定制化"
          )
        ]),
        _vm._v(" "),
        _c(
          "span",
          { staticStyle: { float: "right" } },
          [
            _vm._v("\n            Sheet页表：\n            "),
            _c(
              "el-select",
              {
                attrs: { placeholder: "切换 模板页表" },
                on: {
                  change: function($event) {
                    _vm.setCurSheetFieldList()
                  }
                },
                model: {
                  value: _vm.curSheetName,
                  callback: function($$v) {
                    _vm.curSheetName = $$v
                  },
                  expression: "curSheetName"
                }
              },
              _vm._l(_vm.dataSheetNames, function(sheetName) {
                return _c("el-option", {
                  attrs: { label: sheetName, value: sheetName }
                })
              })
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticStyle: { "margin-left": "40px" } },
              [
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.showColPreview,
                      callback: function($$v) {
                        _vm.showColPreview = $$v
                      },
                      expression: "showColPreview"
                    }
                  },
                  [_vm._v("显示列预览")]
                )
              ],
              1
            )
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showColPreview,
                expression: "showColPreview"
              }
            ],
            staticStyle: {
              width: "100%",
              "margin-top": "10px",
              "overflow-x": "auto"
            }
          },
          [
            _c("table", { staticClass: "simple-tbl" }, [
              _c("tbody", { staticClass: "body" }, [
                _c(
                  "tr",
                  {
                    staticClass: "row",
                    staticStyle: { height: "28px", "line-height": "28px" }
                  },
                  _vm._l(_vm.curSheetFieldList, function(field) {
                    return field.selected
                      ? _c(
                          "td",
                          {
                            staticClass: "cell",
                            staticStyle: { cursor: "default" }
                          },
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  "open-delay": 500,
                                  content: field.name,
                                  placement: "top"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    style: {
                                      fontWeight: field.required
                                        ? "bold"
                                        : "normal",
                                      color: field.required
                                        ? "#000000"
                                        : "#333333"
                                    }
                                  },
                                  [_vm._v(_vm._s(field.title))]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  })
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _vm._l(_vm.curSheetLogicGroups, function(logicGroup) {
          return _c(
            "div",
            { staticStyle: { padding: "10px" } },
            [
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _c("span", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v(_vm._s(logicGroup))
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "group-tags" },
                _vm._l(_vm.curSheetGroupedFields[logicGroup], function(
                  field,
                  index
                ) {
                  return _c(
                    "el-tooltip",
                    {
                      key: field.name,
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        "open-delay": 1000,
                        content: field.name,
                        placement: "top"
                      }
                    },
                    [
                      _c(
                        "el-tag",
                        {
                          class: {
                            required: field.required,
                            selectable: _vm.editMode && !field.required,
                            selected: field.selected
                          },
                          staticStyle: {
                            "text-align": "center",
                            "margin-right": "10px",
                            "margin-bottom": "10px",
                            display: "inline-block",
                            "min-width": "100px"
                          },
                          on: {
                            click: function($event) {
                              _vm.switchFieldSelection(logicGroup, field, index)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(field.title) +
                              "\n                    "
                          )
                        ]
                      )
                    ],
                    1
                  )
                })
              )
            ],
            1
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-80b4340a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80b4340a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/comn/CustXportConfCrud.vue
// module id = 4657
// module chunks = 0